import { z } from "zod";

export const machineAlarm = z.object({
	message: z.string(),
	code: z.number(),
	arguments: z.array(z.string()),
});
